// API Service per upload video con gestione tenant
import axios from "axios";

const BASE_URL =
  window.location.hostname === "localhost" ? "http://localhost:3000" : "";

// Configurazione di axios
const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

interface VideoUploadResponse {
  success: boolean;
  path?: string;
  id?: string;
  message?: string;
  error?: string;
}

interface VideoListResponse {
  success: boolean;
  data?: VideoForMakeItem[];
  pagination?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  error?: string;
}

export interface VideoForMakeItem {
  _id: string;
  file: string;
  caption: string;
  tenant: string;
  createdAt: string;
  updatedAt: string;
}

/**
 * Carica un video con caption e tenant
 */
export const uploadVideo = async (
  file: File,
  caption: string,
  tenant: string
): Promise<VideoUploadResponse> => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("caption", caption.trim());
    formData.append("tenant", tenant);

    const apiKey = process.env.REACT_APP_API_KEY;
    if (!apiKey || apiKey === "your-api-key-here") {
      throw new Error(
        "API-KEY non configurata. Configura REACT_APP_API_KEY nel file .env"
      );
    }

    const response = await fetch(BASE_URL + "/api/upload-video", {
      method: "POST",
      headers: {
        "X-API-KEY": apiKey,
      },
      body: formData,
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || `Errore HTTP: ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("Errore upload video:", error);
    throw error;
  }
};

/**
 * Recupera la lista dei video caricati
 */
export const getVideoList = async (
  tenant?: string,
  limit = 50,
  page = 1
): Promise<VideoListResponse> => {
  try {
    const apiKey = process.env.REACT_APP_API_KEY;
    if (!apiKey || apiKey === "your-api-key-here") {
      throw new Error(
        "API-KEY non configurata. Configura REACT_APP_API_KEY nel file .env"
      );
    }

    let url = `/api/upload-video/list?limit=${limit}&page=${page}`;
    if (tenant) {
      url += `&tenant=${tenant}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "X-API-KEY": apiKey,
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || `Errore HTTP: ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("Errore recupero lista video:", error);
    throw error;
  }
};

/**
 * Verifica la configurazione API
 */
export const checkApiConfiguration = (): {
  isConfigured: boolean;
  error?: string;
} => {
  const apiKey = process.env.REACT_APP_API_KEY;

  if (!apiKey) {
    return {
      isConfigured: false,
      error: "REACT_APP_API_KEY non impostata nel file .env",
    };
  }

  if (apiKey === "your-api-key-here") {
    return {
      isConfigured: false,
      error: "REACT_APP_API_KEY deve essere sostituita con una chiave reale",
    };
  }

  return { isConfigured: true };
};

export default {
  uploadVideo,
  getVideoList,
  checkApiConfiguration,
};
